import { useEffect } from 'react';

import { notificationPermission, PUSH_NAVIGATE_MESSAGE, pushSupport } from '../lib/push-browser';

import { usePushSettings } from './use-push-settings';
import { useThisDevice } from './use-this-device';

/**
 * Mounted once by the admin shell: re-registers this browser's subscription on every load (keys
 * and server key rotate) and routes a notification click that the service worker hands to an
 * open tab.
 */
export function usePushNotifications(navigate: (url: string) => void): void {
  const enabled = pushSupport() === 'supported' && notificationPermission() === 'granted';
  const settings = usePushSettings(enabled);
  useThisDevice(enabled ? settings.data?.publicKey : undefined);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const onMessage = (event: MessageEvent<unknown>) => {
      const data = event.data as { type?: unknown; url?: unknown } | null;
      if (data?.type !== PUSH_NAVIGATE_MESSAGE || typeof data.url !== 'string') return;
      if (data.url.startsWith('/') && !data.url.startsWith('//')) navigate(data.url);
    };
    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => navigator.serviceWorker.removeEventListener('message', onMessage);
  }, [navigate]);
}
